import { ellipseText, makeKTBlock, makeSwal } from './functions';
import { BASE_URL, s3Path } from './variables';
import CryptoJS from 'crypto-js';

const fetchEmployeeData = function (el) {
  const $curEl = $(el);

  $('#modalDetailActivity').modal('show');

  $('#modalDetailActivity #futureFUCard').hide();

  $('#modalDetailActivity [name="editCalendarID"]').val($curEl.attr('data-id'));
  makeKTBlock('#modalDetailActivity form');

  $.post(`${BASE_URL}Activities/getActivityDetails`, {
    type: 'COLLEAGUE',
    id: $curEl.attr('data-id'),
  })
    .done((resp) => {
      if (resp.code != 200) {
        makeKTBlock('#modalDetailActivity form', 'hide');
        makeSwal('Unknown Error has Occured! Please try again!', null, 'error', null, '375px', null, false);
        return;
      }

      $('#modalDetailActivity .activity-row').remove();
      $('#modalDetailActivity .modal-body').html(resp.page);
      $('#modalDetailActivity [name="curDescription"]').attr('readonly', true);

      const curResp = resp.data;
      $('#buttonsave, #editStatusHolder').show();
      if (curResp.CREATOR_ID == curUSERSN) {
        $('#buttonsave, #editStatusHolder').hide();
      } else {
        $('#buttonsave, #editStatusHolder').show();
        $('#modalDetailActivity [name="curDescription"]').attr('readonly', false);

        if (curResp.STATUS == 'COMPLETED') {
          $('#buttonsave, #editStatusHolder').hide();
          $('#modalDetailActivity [name="curDescription"]').attr('readonly', true);
          $('#modalDetailActivity [name="curStatus"]').attr('disabled', true).attr('readonly', true).prop('checked', true);
        } else {
          $('#modalDetailActivity [name="curStatus"]').attr('disabled', false).prop('checked', false);
        }
      }

      if (curResp.PROJECT_ID) {
        $('#projectNameHolder').show();
      } else {
        $('#projectNameHolder').hide();
      }

      if (curResp.FILE_ID && resp.images) {
        $.each(resp.images, function (i, item) {
          var hash = CryptoJS.MD5(item.ACTIVITY_ID).toString();
          var shortHash = hash.substring(0, 10);
          let curUrl = item.AWS_FILE ? item.AWS_FILE : `${s3Path}/Task/${shortHash}/${item.ENCRYPTED_FILE}`;
          $('#documentTaskHolder').append(`
              <span class="label label-inline label-lg label-light-dark mr-2 mb-2">
                <a target="_blank" href="${curUrl}">${ellipseText(item.ORIGINAL_FILE, 25)}</a>
              </span>
            `);
        });

        $('#documentTaskHolder').show();
      } else {
        $('#documentTaskHolder').hide();
      }

      makeKTBlock('#modalDetailActivity form', 'hide');
    })
    .fail((err) => {
      console.log('Error', err);
      KTApp.unblock('#modalDetailActivity');

      Swal.fire({
        html: 'Invalid ID! Please try again',
        icon: 'error',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });
    });
};

export { fetchEmployeeData };
